package services.auth.http

import it.neckar.lizergy.model.company.UsersAndCompanies
import it.neckar.rest.RestResponse
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Response for
 */
@Serializable
sealed interface FetchUsersAndCompaniesResponse : RestResponse<UsersAndCompanies> {

  @Serializable
  @SerialName("good")
  data class Good internal constructor(override val data: UsersAndCompanies) : FetchUsersAndCompaniesResponse, RestResponse.GoodResponse<UsersAndCompanies> {

    @Deprecated("Inline!", ReplaceWith("data"))
    fun toUsersAndCompanies(): UsersAndCompanies {
      return data
    }
  }

  @Serializable
  @SerialName("bad/Failed")
  data object Failed : FetchUsersAndCompaniesResponse, RestResponse.BadResponse<UsersAndCompanies>

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(data: UsersAndCompanies): FetchUsersAndCompaniesResponse = Good(data)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(): FetchUsersAndCompaniesResponse = Failed

    /**
     * Creates a success method for non-null results, failure for null results
     */
    fun createFor(data: UsersAndCompanies?): FetchUsersAndCompaniesResponse {
      return if (data != null) {
        good(data)
      } else {
        bad()
      }
    }
  }
}
